/**
 * Created by koqiui on 2017-04-09.
 */
import { MsgBox, Vue } from '../../app.vues';
import { Utils } from '../../app.base';

import SwbAssetStockInItemList from './AssetStockInItemList';
import SwbGoodsRecvVoucherItemSelect from './GoodsRecvVoucherItemSelect';
import SwbOrderGoodsAllocFormTemplate from './OrderGoodsAllocFormTemplate';
import SwbAllocFormImpCheck from './AllocFormImpCheck';
import SwbAllocFormFormatExpl from './AllocFormFormatExpl';
import SwbGoodsRecvVoucherListForSelect from './GoodsRecvVoucherListForSelect';
import SwbGoodsRecvReturnItemList from './GoodsRecvReturnItemList';

Vue.regist(SwbAssetStockInItemList);

Vue.regist(SwbGoodsRecvVoucherItemSelect);

Vue.regist(SwbOrderGoodsAllocFormTemplate);

Vue.regist(SwbAllocFormImpCheck);

Vue.regist(SwbAllocFormFormatExpl);

// 资产入库条目列表dlg
export function showSwbAssetStockInItemListDialog(voucherId, ioFlag, buyerShopId, shipVoucherId, assetTypes, callback, thisArg) {
    if(Utils.isNoB(voucherId)) {
        MsgBox.warning('参数错误！');
        return;
    }
    if(Utils.isNoB(ioFlag)) {
        ioFlag = 1;
    }
    let assetType = assetTypes[0];
    let theDlg = Vue.$showDialog({
        title: (assetType == 2 ? '耗材' : '资产') + '入库条目 - 保存',
        width: -400,
        height: 800,
        cancelVisible: true,
        okVisible: true,
        template: '<swb-asset-stockIn-item-list :shipVoucherId="shipVoucherId" :voucherId="voucherId" :ioFlag="ioFlag" :buyerShopId="buyerShopId" :assetTypes="assetTypes" ref="swb_asset_stockIn_item_list"></swb-asset-stockIn-item-list>',
        data: {
            voucherId: voucherId,
            ioFlag: ioFlag,
            buyerShopId: buyerShopId,
            shipVoucherId: shipVoucherId,
            assetTypes: assetTypes
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_asset_stockIn_item_list.getDlgResult() || {};
            if(result.type == 'info') {
                let resData = result.data;
                //
                callback(theDlg, resData);
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        }
    });
}

// 收货单条目选择dlg
// voucherId 必传； ioFlag 必传；devcIoDone 可不传；selectItems：回显使用；useFor: 用途，可根据自己的情况设定值，可不传；
export function showGoodsRecvVoucherItemListForSelectDialog(voucherId, recvVoucherItemId, ioFlag, devcIoDone, selectItems, useFor, assetTypes, callback, thisArg) {
    if(Utils.isNoB(ioFlag)) {
        ioFlag = 1;
    }
    let title = '收货条目 - 选择';
    if(!Utils.isNoB(useFor) && useFor == 'returnExchg') {
        title = '退换商品 - 选择';
    }
    let theDlg = Vue.$showDialog({
        title: title,
        width: -200,
        height: 700,
        cancelVisible: true,
        okVisible: true,
        template: '<swb-goods-recv-voucher-item-select :voucherId="voucherId" :recvVoucherItemId="recvVoucherItemId" :ioFlag="ioFlag" :devcIoDone="devcIoDone" :selectItems="selectItems" :useFor="useFor" :assetTypes="assetTypes" ref="swb_goods_recv_voucher_item_select"></swb-goods-recv-voucher-item-select>',
        data: {
            selectItems: selectItems,
            voucherId: voucherId,
            recvVoucherItemId: recvVoucherItemId,
            devcIoDone: devcIoDone,
            ioFlag: ioFlag,
            useFor: useFor,
            assetTypes: assetTypes,
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_goods_recv_voucher_item_select.getDlgResult() || {};
            if(result.type == 'info') {
                let recvItems = result.data;
                callback(recvItems);
                return true;
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

Vue.regist(SwbGoodsRecvVoucherListForSelect);

// 收货单选择dlg
export function showGoodsRecvVoucherListForSelectDialog(dlgConfig, callback) {
    let checkBox = dlgConfig['checkBox'] == null ? false : dlgConfig['checkBox'];
    let selectIds = dlgConfig['selectIds'] || [];
    let filter = dlgConfig['filter'] || {}; // 可直接传任意数据库字段即可，内部无需处理
    let theDlg = Vue.$showDialog({
        title: '收货单 - 选择',
        width: -200,
        height: 700,
        cancelVisible: true,
        okVisible: true,
        template: '<swb-goods-recv-voucher-list-for-select :checkBox="checkBox" :selectIds="selectIds" :filter="filter" ref="swb_goods_recv_voucher_list_for_select"></swb-goods-recv-voucher-list-for-select>',
        data: {
            checkBox: checkBox,
            selectIds: selectIds,
            filter: filter
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_goods_recv_voucher_list_for_select.getDlgResult() || {};
            if(result.type == 'info') {
                let recvVouchers = result.data;
                callback(recvVouchers);
                return true;
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

Vue.regist(SwbGoodsRecvReturnItemList);

// 退换货明细
export function showGoodsRecvReturnItemListDialog(dlgConfig, callback) {
    let title = dlgConfig['title'] || null;
    let recvVoucherId = dlgConfig['recvVoucherId'] || null;
    let recvVoucherItemId = dlgConfig['recvVoucherItemId'] || null;
    let returnQuantity = dlgConfig['returnQuantity'] || null;
    let exchgQuantity = dlgConfig['exchgQuantity'] || null;
    let goodsRecvReturnItemList = dlgConfig['goodsRecvReturnItemList'] || [];
    let optionFlag = dlgConfig['optionFlag'] || null;
    if(Utils.isNoB(title)) {
        title = '退换货明细';
    }
    let theDlg = Vue.$showDialog({
        title: title,
        width: -200,
        height: 700,
        cancelVisible: true,
        okVisible: true,
        template: '<swb-goods-recv-return-item-list :recvVoucherId="recvVoucherId" :recvVoucherItemId="recvVoucherItemId" :returnQuantity="returnQuantity" :exchgQuantity="exchgQuantity" :goodsRecvReturnItems="goodsRecvReturnItems" :optionFlag="optionFlag" ref="swb_goods_recv_return_item_list"></swb-goods-recv-return-item-list>',
        data: {
            recvVoucherId: recvVoucherId,
            recvVoucherItemId: recvVoucherItemId,
            returnQuantity: returnQuantity,
            exchgQuantity: exchgQuantity,
            goodsRecvReturnItems: goodsRecvReturnItemList,
            optionFlag: optionFlag,
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_goods_recv_return_item_list.getDlgResult() || {};
            if(result.type == 'info') {
                let goodsRecvReturnItemList = result.data;
                callback(goodsRecvReturnItemList);
                return true;
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

import SwbGoodsRecvReturnItemListView from './GoodsRecvReturnItemListView';

Vue.regist(SwbGoodsRecvReturnItemListView);

// 退换货明细
export function showGoodsRecvReturnItemListViewDialog(dlgConfig, callback) {
    let recvVoucherId = dlgConfig['recvVoucherId'] || null;
    let recvVoucherItemId = dlgConfig['recvVoucherItemId'] || null;
    let optionFlag = dlgConfig['optionFlag'] || null;
    let title = '退换货明细';
    if(!Utils.isNoB(optionFlag) && optionFlag == 'return') {
        title = '退货明细';
    } else if(!Utils.isNoB(optionFlag) && optionFlag == 'exchg') {
        title = '换货明细';
    }
    let theDlg = Vue.$showDialog({
        title: title,
        width: -200,
        height: 700,
        cancelVisible: true,
        cancelText: '关闭',
        okVisible: false,
        showCloseBtn: true,
        template: '<swb-goods-recv-return-item-list-view :recvVoucherId="recvVoucherId" :recvVoucherItemId="recvVoucherItemId" :optionFlag="optionFlag" ref="swb_goods_recv_return_item_list_view"></swb-goods-recv-return-item-list-view>',
        data: {
            recvVoucherId: recvVoucherId,
            recvVoucherItemId: recvVoucherItemId,
            optionFlag: optionFlag
        },
        okClicked: function () {
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

// 导出配货模板
export function showAllocFormTemplateDialog(callback) {
    let theDlg = Vue.$showDialog({
        title: '配货模板 - 下载',
        width: -200,
        height: 800,
        cancelVisible: true,
        okVisible: true,
        template: '<swb-order-goods-alloc-form-template ref="swb_order_goods_alloc_form_template"></swb-order-goods-alloc-form-template>',
        data: {},
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_order_goods_alloc_form_template.getDlgResult() || {};
            if(result.type == 'info') {
                let resData = result.data;
                //
                callback(resData, theDlg);
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        }
    });
}

// 配货导入检查
export function openAllocFormImpCheckDlg(fileObj, callback) {
    let theDlg = null;
    theDlg = Vue.$showDialog({
        title: '配货导入 - 检查',
        width: -100,
        height: -150,
        okVisible: false,
        cancelVisible: false,
        extVisible: true,
        showCloseBtn: true,
        okText: '整体导入',
        extText: '关闭',
        cancelText: '整体检查',
        template: '<swb-alloc-form-imp-check @other-close="otherClose" :rootWidth="dlgBodyWidth" :rootHeight="dlgBodyHeight" :fileObj="fileObj" ref="swb_alloc_form_imp_check"></swb-alloc-form-imp-check>',
        data: {
            fileObj: fileObj,
            dlgBodyWidth: 900,
            dlgBodyHeight: 680,
        },
        methods: {
            dlgBodyResized(width, height) {
                this.dlgBodyWidth = width;
                this.dlgBodyHeight = height;
            },
            otherClose(result) {
                callback(result, theDlg);
            }
        },
        okClicked: function () {
        },
        cancelClicked: function () {
        }
    });
}

// 配货导入说明
export function openAllocFormFormatExplDlg() {
    //
    let theDlg = Vue.$showDialog({
        title: '配货导入说明 - 查看',
        width: 1200,
        height: 800,
        showCloseBtn: true,
        okVisible: false,
        cancelText: '关闭',
        template: '<div class = "">' +
            '<swb-alloc-form-format-expl ref="swb_alloc_form_format_expl"></swb-alloc-form-format-expl>' +
            '</div>',
        data: {},
        okClicked: function () {
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

import SwbGoodsWrntExtVoucherSave from './GoodsWrntExtVoucherSave'

Vue.regist(SwbGoodsWrntExtVoucherSave)

// 商品售后延保保存 callback(id)
export function openGoodsWrntSaveDlg(callback, id, show) {
    let title = Utils.isNoB(id) ? '商品售后延保 - 新增' : '商品售后延保 - 修改'
    //
    let theDlg = Vue.$showDialog({
        title: title,
        width: 1200,
        height: 800,
        showCloseBtn: true,
        template: '<div class = "">' +
            '<swb-goods-wrnt-ext-voucher-save :id="id" :show="show" ref="swb_goods_wrnt_ext_voucher_save"></swb-goods-wrnt-ext-voucher-save>' +
            '</div>',
        data: {
            id: id,
            show: show
        },
        okClicked: function () {
            let result = this.$refs.swb_goods_wrnt_ext_voucher_save.getDlgResult()
            if(result.type == 'info') {
                let resData = result.data;
                //
                callback(resData, theDlg);
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        }
    })
}

import SwbGoodsOrderInfoForPdf from './GoodsOrderInfoForPdf'

Vue.regist(SwbGoodsOrderInfoForPdf);

// 商品售后延保保存 callback(id)
export function openGoodsOrderInfoForPdf(goodsOrderId, callback) {
    let theDlg = Vue.$showDialog({
        title: '商品订单PDF打印',
        width: 1200,
        height: 800,
        okVisible: false,
        showCloseBtn: false,
        template: '<swb-goods-order-info-for-pdf :goodsOrderId="goodsOrderId" ref="swb_goods_order_info_for_pdf"></swb-goods-order-info-for-pdf>',
        data: {
            goodsOrderId: goodsOrderId
        },
        okClicked: function () {
            let result = this.$refs.swb_goods_order_info_for_pdf.getDlgResult();
            if(result.type == 'info') {
                let resData = result.data;
                //
                callback(resData, theDlg);
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        },
        cancelClicked: function () {
            callback()
        }
    })
}

import EsignBizFormInfo from './EsignBizFormInfo.vue';
import esignBizFormApi from '../../api/esignBizForm';

Vue.regist(EsignBizFormInfo)

export function openOnlineSignForm(row, allowUpFlow, callback) {
    let okTextStr = ''
    let okVisible = true;
    if(row.signFlowStatus == 0) {
        //未发起
        okTextStr = '发起签署';
    } else if(row.signFlowStatus == 3 || row.signFlowStatus == 5 || row.signFlowStatus == 7) {
        //已撤销 已过期 已拒签
        // okTextStr = '重新发起签署';
        okVisible = false;
    } else {
        okVisible = false;
    }
    let theDlg = Vue.$showDialog({
        title: '签署信息',
        width: 800,
        height: 650,
        okVisible: okVisible,
        okText: okTextStr,
        cancelText: '关闭',
        template: '<div class = "">' +
            '<swb-esign-biz-form-info @esign-again-result="handleEsignAgainResult" :esignBizForm="esignBizForm" :allowUpFlow="allowUpFlow" ref="swb_esign_biz_form_info"></swb-esign-biz-form-info>' +
            '</div>',
        data: {
            esignBizForm: row,
            allowUpFlow: allowUpFlow
        },
        okClicked: function () {
            let resData = this.$refs.swb_esign_biz_form_info.getDlgResult();
            if(resData.type == 'info') {
                let msgBoxDlg = MsgBox.loading();
                esignBizFormApi.initiateEsign(resData.data, function (result) {
                    msgBoxDlg.close()
                    if(result.type == 'info') {
                        MsgBox.success('发起签署成功');
                        theDlg.close();
                        callback();
                    } else {
                        MsgBox.warning(result.message)
                    }
                })
                return false;
            } else {
                MsgBox.warning(resData.message)
                return false;
            }

        },
        methods: {
            handleEsignAgainResult(newId) {
                theDlg.close()
                callback(newId)
            }
        }
    });
}

import SwbEsignBizFormInfoView from './EsignBizFormInfoView.vue';

Vue.regist(SwbEsignBizFormInfoView)

export function openOnlineSignFormView(id, callback) {
    let okTextStr = ''
    let okVisible = false;
    Vue.$showDialog({
        title: '签署信息',
        width: 800,
        height: 650,
        okVisible: okVisible,
        okText: okTextStr,
        cancelText: '关闭',
        template: '<div class = "">' +
            '<swb-esign-biz-form-info-view  :id="id" ref="swb_esign_biz_form_info"></swb-esign-biz-form-info-view>' +
            '</div>',
        data: {
            id: id
        }
    });
}

import SwbEsignDefSealSelect from './EsignDefSealSelect.vue';

export function showEsignDefSealSealectDlg(dlgConfig, callback) {
    Vue.regist(SwbEsignDefSealSelect);
    //
    dlgConfig = dlgConfig || {};
    let esignOrgId = dlgConfig.esignOrgId || {};
    let mainCom = dlgConfig.mainCom;
    //
    let theDlg = Vue.$showDialog({
        title: '电子签章印章选择',
        width: 900,
        height: 800,
        template: '<swb-esign-def-seal-for-select :esignOrgId="esignOrgId" :mainCom="mainCom" ref="swb_esign_def_seal_for_select"></swb-esign-def-seal-for-select>',
        data: {
            esignOrgId: esignOrgId,
            mainCom: mainCom
        },
        okClicked: function () {
            let result = this.$refs.swb_esign_def_seal_for_select.getDlgResult() || {};
            if(result != null) {
                if(result.type == 'info') {
                    let esignDefSealSeal = result.data || [];
                    if(typeof callback == 'function') {
                        callback(esignDefSealSeal, theDlg);
                    }
                } else {
                    Toast.show(result.message, 5000);
                }
            }
            return false;
        }
    });
}





//////////////////
// WEBPACK FOOTER
// ./src/compo/order/dialog.js
// module id = 81
// module chunks = 0